import React, { Component } from 'react';
import * as Config from './../config/Config';
import * as Common from './../helpers/Common';
import * as User from './../helpers/User';

const $=window.$;

class Radio extends Component {
	constructor(props) {
		super(props);

        this.state={        	
        };
		this.getLrinfo=this.getLrinfo.bind(this);

	}	

	componentDidMount() {
		/*
		var text_max = 500;
		$('#max-char').html(text_max +'  '+'characters left');
		
		$('#que-box').keyup(function() {
			var text_length = $('#que-box').val().length;
			var text_remaining = text_max - text_length;
			if(text_remaining < 0)
			{
				$('#que-box').val('');
			}	
			$('#max-char').html(text_remaining+'  '+'characters left');
			
		});

		$("#drop-btn").click(function(){
			$('#que-box').val('');
			$('#max-char').html('500' +'  '+'characters left');
		});
		//Show Suggestion
		$('#suggetion-input').focusin(function(){
			$('.hub-container').fadeOut(500);
			$('.suggestion-box').fadeIn(500);
		});
		$('#srh-btn').click(function(){
			$('.suggestion-box').fadeIn(500);
		});
		$('.clear-btn').click(function(){
			$('.suggestion-box').fadeOut(500);
		});
		
		$('.hun-btn').focusin(function(){	
			$('.suggestion-box').fadeOut(500);
			$('.hub-container').fadeIn(500);
		});
		$('#hub-close').click(function(){
			$('.hub-container').fadeOut(500);
		});
		
		//arechive tab

		$('.archives li').click(function(){
			$(this).find('.fa').toggleClass('fa-plus fa-minus');
			$(this).find('div').toggleClass('a-display');
		});

		$('.archives li').children('div').click(function(e){ e.stopPropagation();})
		*/
	}

	getLrinfo(type,lr_id,dlr_id){
		this.props.switchPanel(type,lr_id,dlr_id);
	}

		render() {

		return (
		 <section id="contentsection" className="contentarea">
          {/* <div className="inner-title-bg journey-tit-bg">
            <h1> <span> <img src={process.env.PUBLIC_URL+'/images/rad-img.jpg'} align="absmiddle" alt="Collaboration feature in i-meta" border="0" /> </span>Radio<br />
              <span className="subtitle">Clarify your doubts privately</span></h1>
          </div> */}

          {/* <div className="my-collabrate">
					
					<section className="ask rad">
						<form>
						<div className="">
							<textarea id="que-box"></textarea>
							<ul className="action-btn">
								<li className="left" style={{paddingLeft:'0'}}><button className="loud" type="button"><img src={process.env.PUBLIC_URL+'/images/rad-lod.jpg'} /></button></li>
								<li className="right" id="Ask-btn"><a href="javascript:void(0)"> Ask</a></li>
							</ul>
							<div className="clear"></div>
							<ul className="qa-li">
								<li className="your-q">
									<div className="left">
										You: 
									</div>
									<div className="right">
										Hello Radio! Can I ask you a question about an orthodox system of accounting?
									</div>
								</li>
								<li className="radio-and">
									<div className="left">
										<img src={process.env.PUBLIC_URL+'/images/radio-ico-alt.jpg'} />
									</div>
									<div className="right">
										Sure, I will try my best to answer.
									</div>
								</li>
								<li className="your-q">
									<div className="left">
										You: 
									</div>
									<div className="right">
									What are the advantages of double accounting system? Do we follow this system in India?
									</div>
								</li>
								<li className="radio-and">
									<div className="left">
										<img src={process.env.PUBLIC_URL+'/images/radio-ico-alt.jpg'} />
									</div>
									<div className="right">
										<p>Double accounting system has several advantages, even though it is a bit tedious to keep. One, it eliminates errors. Two, it creates multiple accounts by default. Three, it makes sure that the different account heads are created in the system.
										<br/>
										<br/>
										For more reading, visit: www.cai.com/accountingsystems
										<br/>
										<br/>
										Is there anything else I can help you with?</p>
										<br/>
										
									</div>
								</li>
								<li className="qa-li">
								</li><li className="your-q">
									<div className="left">
										You: 
									</div>
									<div className="right">
										Nothing else. Thank you, Radio
									</div>
								</li>
								<li className="radio-and">
									<div className="left">
										<img src={process.env.PUBLIC_URL+'/images/radio-ico-alt.jpg'} />
									</div>
									<div className="right">
									Please rate my answers; it will help me improve. Thank you
									<div className="rating">
										<span><i className="fa fa-star-o"></i></span> <span><i className="fa fa-star-o"></i></span><span><i className="fa fa-star-o"></i></span> <span><i className="fa fa-star-o"></i></span> <span><i className="fa fa-star-o"></i></span>	
									</div>
									</div>
								</li>
							</ul>
							<div className="action-save">
								<button type="button" className="save"> Save this interaction</button>
								<button type="button"> Bye, Radio!</button> 
							</div>
						</div>
						</form>
					</section>
				</div>       */}

		   
    <div className="radio-title">
		<h2>Radio</h2>
		<p>Clarify your doubts privately</p>
    </div>
		<div className="radio-body">
			<textarea className="big-textarea"></textarea>
			<div className="btn-container">
				<a href="javascript:void(0);" className="btn btn-ask">Ask</a>
				<a href="javascript:void(0);" className="btn btn-loud"></a>
			</div>
			<ul className="chat-babbles">
				<li className="user">
					<div className="imgHead"></div>
					<div className="cnt"><p>Hello Radio! Can I ask you a question about an orthodox system of accounting?</p></div>
				</li>
				<li className="radio-ai">
					<div className="imgHead"></div>
					<div className="cnt"><p>Sure, I will try my best to answer.</p></div>
				</li>
				<li className="user">
					<div className="imgHead"></div>
					<div className="cnt"><p>What are the advantages of double accounting system? Do we follow this system in India?</p></div>
				</li>
				<li className="radio-ai">
					<div className="imgHead"></div>
					<div className="cnt">
						<p>Double accounting system has several advantages, even though it is a bit tedious to keep. One, it eliminates errors. Two, it creates multiple accounts by default. Three, it makes sure that the different account heads are created in the system.</p>
						<p>For more reading, visit: <a href="http://www.cai.com/accountingsystems" target="_blank">www.cai.com/accountingsystems</a></p>
						<p>Is there anything else I can help you with?</p>
					</div>
				</li>
				<li className="user">
					<div className="imgHead"></div>
					<div className="cnt"><p>Nothing else. Thank you, Radio</p></div>
				</li>
				<li className="radio-ai">
					<div className="imgHead"></div>
					<div className="cnt"><p>Please rate my answers; it will help me improve. Thank you</p></div>
				</li>
			</ul>
			<div className="radio-rating-container">
				<a href="javascript:void(0);"><img src="images/radio/radio-no-rating.png" alt="ratings" /></a>			
				<a href="javascript:void(0);"><img src="images/radio/radio-no-rating.png" alt="ratings" /></a>			
				<a href="javascript:void(0);"><img src="images/radio/radio-no-rating.png" alt="ratings" /></a>			
				<a href="javascript:void(0);"><img src="images/radio/radio-no-rating.png" alt="ratings" /></a>			
				<a href="javascript:void(0);"><img src="images/radio/radio-no-rating.png" alt="ratings" /></a>			
			</div>
			<div className="bottom-btn-container">
				<a href="javascript:void(0);" className="btn btn-save">Save this interaction</a>			
				<a href="javascript:void(0);" className="btn btn-bye"> Bye, Radio!</a>			
			</div>
		</div>
	</section>
			);
		}
}


export default Radio;




// WEBPACK FOOTER //
// ./src/radio/Radio.js